import { Component, OnInit, ViewChild, NgZone } from '@angular/core';
import { SohoDataGridComponent, SohoBusyIndicatorDirective } from "ids-enterprise-ng";
import { CapacityModelService } from "../services/CapacityModel-Service";
import { AuthHelper } from './../services/authHelper';
import { UserData } from '../shared/models/user.model';

@Component({
  selector: 'app-upload-requests',
  templateUrl: './upload-requests.component.html',
  styleUrls: ['./upload-requests.component.css']
})
export class UploadRequestsComponent implements OnInit {
  showBusy = true;
  Message = "Loading...";
  @ViewChild(SohoDataGridComponent) sohoDataGridComponent!: SohoDataGridComponent;
  @ViewChild(SohoBusyIndicatorDirective, { static: true }) busyIndicator?: SohoBusyIndicatorDirective;
  public data!: any[];
  public grid_Columns!: SohoDataGridColumn[];
  userData = new UserData();
  constructor(private capacityModelService: CapacityModelService,
    private authhelper: AuthHelper) { }

  ngOnInit(): void {
    this.userData = JSON.parse(localStorage.getItem("userprofile")!);
    if (this.userData != null && this.userData != undefined) {      
      this.GetRequestDetails();
    }
  }
  GetRequestDetails() {
    this.data = [];
    this.grid_Columns = [];
    this.start();
    this.capacityModelService.GetUploadRequests(this.userData.Email).subscribe(
      territory => {
        this.data = territory;
        this.grid_Columns = this.gridColumns;
        this.stop();
      },
      (error: Response) => {
        console.log(error);
        this.stop();
      }
    );
  }
  start() {
    (this.busyIndicator as any).activated = true;
  }

  stop() {
    (this.busyIndicator as any).activated = false;
  }
  gridColumns = [

    {
      id: "requestid",
      name: "Request ID",
      field: "requestid",
      filterType: 'text',
      hidden: false,
      formatter: Soho.Formatters.Text
    },
    {
      id: "status",
      name: "Status",
      field: "status",
      filterType: 'text',
      sortable: false,
      formatter: Soho.Formatters.Text
    },
    {
      id: "requesttype",
      name: "Request Type",
      field: "requesttype",
      filterType: 'text',
      sortable: true,
      formatter: Soho.Formatters.Text
    },
    {
      id: "fiscalyear",
      name: "Fiscal Year",
      sortable: true,
      field: "fiscalyear",
      filterType: 'text',
      formatter: Soho.Formatters.Text
    },
    {
      id: "createdby",
      name: "Created By",
      field: "createdby",
      filterType: 'text',
      sortable: false,
      formatter: Soho.Formatters.Text
    },
    {
      id: "created",
      name: "Created On",
      field: "created",
      filterType: 'date',
      formatter: Soho.Formatters.Date,
      dateFormat: 'M/d/yyyy hh:mm:ss'
    },
    {
      id: "errormessage",
      name: "Eror Message",
      sortable: true,
      field: "errormessage",
      filterType: 'text',
      formatter: Soho.Formatters.Text
    }
   
  ];
}
